import { render, staticRenderFns } from "./myTask.vue?vue&type=template&id=668f10b8&scoped=true"
import script from "./myTask.vue?vue&type=script&lang=js"
export * from "./myTask.vue?vue&type=script&lang=js"
import style0 from "./myTask.vue?vue&type=style&index=0&id=668f10b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668f10b8",
  null
  
)

export default component.exports